import React, { useEffect, useState } from "react";
import Card from "components/Card/Card";

import {
  Text,
  Flex,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  Button,
  Textarea,
  RadioGroup,
  Stack,
  SimpleGrid,
  AbsoluteCenter,
  Center,
  Editable,
  EditablePreview,
  EditableTextarea,
  NumberInput,
  NumberInputField,
  NumberIncrementStepper,
  NumberDecrementStepper,
  NumberInputStepper,
  useColorModeValue,
  useColorMode,
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import CustomCheckbox from "../../../components/Checkbox/CustomCheckbox";
import axios from "axios";
import apiUrl from "variables/api";
import { toast } from 'react-toastify';

const initialValues = {
    vehiclesTotal: "",
    fireVehicles: "",
    specialistVehicles: "",
    aircrafts: "",
    watercrafts: "",
    dispatches: "",
    sgrtDispatches: "",
    sgchemDispatches: "",
    sgrmedDispatches: "",
    mostUsedVehicle: "",
    leastUsedVehicle: "",
    incidentsWithServiceVehicles: "",
    equipmentFailures: "",
    withdrawnEquipment: "",
};

const validate = (values) => {
  const errors = {};
  const requiredFields = Object.keys(initialValues);

  requiredFields.forEach(field => {
    if (!values[field] && values[field] !== 0) {
          errors[field] = "To pole jest obowiazkowe";
      }
  });

  return errors;
}

function Page() {
  const { colorMode } = useColorMode();
  const [formData, setFormData] = useState(initialValues);
  const formikRef = React.useRef();
//   const source = axios.CancelToken.source();
  useEffect(() => {
    axios.get(apiUrl + '/data/jrg-sum', {
      headers: {'x-access-token': localStorage.getItem('token')},
    //   cancelToken: source.token,
    })
    .then(response => {
      if (response.data.length !== 0) {
        console.log(response.data.dataOne);
        setFormData(response.data.dataOne);
        formikRef?.current?.resetForm({ values: response.data.dataOne});
      }
    })
    .catch(error => {
      console.error(error);
      toast.error('Napotkano błąd podczas pobierania danych z API');
    });

    // return () => {
    //     source.cancel();
    //   };
  }, []);
  const handleSubmit = (values, { setSubmitting, resetForm }) => {
      console.log('Dane formularza', values)

      setFormData(values);
      axios.post(apiUrl + '/data/jrg-one', values, {
          headers: {'x-access-token': localStorage.getItem('token')}
      })
          .then(response => {
              if (response.data.success) {
                  formikRef.current.setSubmitting(false)
                  return toast.success('Pomyślnie wysłano raport JRG 1')
              } else {
                formikRef.current.setSubmitting(false)
                return toast.error('Napotkano błąd podczas wysyłania raportu JRG 1')
              }
          })
          .catch(error => {
              console.error(error);
              formikRef.current.setSubmitting(false)
              toast.error('Napotkano błąd podczas połączenia z API')
          });
  };

  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <Card minH="125px">
        <Text fontSize="2xl" fontWeight="bold">
          JRG 1
        </Text>
        <Formik
          initialValues={initialValues}
          validate={validate}
          // validateOnChange={false}
          // validateOnBlur={false}
          onSubmit={handleSubmit}
          innerRef={formikRef}
        >
          {({ isSubmitting, formik }) => (
            <Form>
              <SimpleGrid columns={1} gap={2}>
                <Field name="vehiclesTotal">
                    {({ field, form }) => (
                        <FormControl
                            id="vehiclesTotal"
                            isRequired
                            isInvalid={form.errors.vehiclesTotal && form.touched.vehiclesTotal}
                        >
                            <Flex direction={"row"} gap={"10px"} alignItems={"center"} justifyContent={"left"}>
                                <Text>Ilość pojazdów razem</Text>
                                <Input type="number" {...field} w={"100px"} />
                            </Flex>
                            <FormErrorMessage>{form.errors.vehiclesTotal}</FormErrorMessage>
                        </FormControl>
                    )}
                </Field>

                <Field name="fireVehicles">
                    {({ field, form }) => (
                        <FormControl
                            id="fireVehicles"
                            isRequired
                            isInvalid={form.errors.fireVehicles && form.touched.fireVehicles}
                        >
                            <Flex direction={"row"} gap={"10px"} alignItems={"center"} justifyContent={"left"}>
                                <Text>Ilość pojazdów gaśniczych</Text>
                                <Input type="number" {...field} w={"100px"} />
                            </Flex>
                            <FormErrorMessage>{form.errors.fireVehicles}</FormErrorMessage>
                        </FormControl>
                    )}
                </Field>

                <Field name="specialistVehicles">
                    {({ field, form }) => (
                        <FormControl
                            id="specialistVehicles"
                            isRequired
                            isInvalid={form.errors.specialistVehicles && form.touched.specialistVehicles}
                        >
                            <Flex direction={"row"} gap={"10px"} alignItems={"center"} justifyContent={"left"}>
                                <Text>Ilość pojazdów specjalistycznych</Text>
                                <Input type="number" {...field} w={"100px"} />
                            </Flex>
                            <FormErrorMessage>{form.errors.specialistVehicles}</FormErrorMessage>
                        </FormControl>
                    )}
                </Field>

                <Field name="aircrafts">
                    {({ field, form }) => (
                        <FormControl
                            id="aircrafts"
                            isRequired
                            isInvalid={form.errors.aircrafts && form.touched.aircrafts}
                        >
                            <Flex direction={"row"} gap={"10px"} alignItems={"center"} justifyContent={"left"}>
                                <Text>Ilość statków powietrznych</Text>
                                <Input type="number" {...field} w={"100px"} />
                            </Flex>
                            <FormErrorMessage>{form.errors.aircrafts}</FormErrorMessage>
                        </FormControl>
                    )}
                </Field>

                <Field name="watercrafts">
                    {({ field, form }) => (
                        <FormControl
                            id="watercrafts"
                            isRequired
                            isInvalid={form.errors.watercrafts && form.touched.watercrafts}
                        >
                            <Flex direction={"row"} gap={"10px"} alignItems={"center"} justifyContent={"left"}>
                                <Text>Ilość pojazdów pływających</Text>
                                <Input type="number" {...field} w={"100px"} />
                            </Flex>
                            <FormErrorMessage>{form.errors.watercrafts}</FormErrorMessage>
                        </FormControl>
                    )}
                </Field>

                <Field name="dispatches">
                    {({ field, form }) => (
                        <FormControl
                            id="dispatches"
                            isRequired
                            isInvalid={form.errors.dispatches && form.touched.dispatches}
                        >
                            <Flex direction={"row"} gap={"10px"} alignItems={"center"} justifyContent={"left"}>
                                <Text>Ilość dyspozycji do zdarzeń</Text>
                                <Input type="number" {...field} w={"100px"} />
                            </Flex>
                            <FormErrorMessage>{form.errors.dispatches}</FormErrorMessage>
                        </FormControl>
                    )}
                </Field>

                <Field name="sgrtDispatches">
                    {({ field, form }) => (
                        <FormControl
                            id="sgrtDispatches"
                            isRequired
                            isInvalid={form.errors.sgrtDispatches && form.touched.sgrtDispatches}
                        >
                            <Flex direction={"row"} gap={"10px"} alignItems={"center"} justifyContent={"left"}>
                                <Text>Ilość wyjazdów SGRT</Text>
                                <Input type="number" {...field} w={"100px"} />
                            </Flex>
                            <FormErrorMessage>{form.errors.sgrtDispatches}</FormErrorMessage>
                        </FormControl>
                    )}
                </Field>

                <Field name="sgchemDispatches">
                    {({ field, form }) => (
                        <FormControl
                            id="sgchemDispatches"
                            isRequired
                            isInvalid={form.errors.sgchemDispatches && form.touched.sgchemDispatches}
                        >
                            <Flex direction={"row"} gap={"10px"} alignItems={"center"} justifyContent={"left"}>
                                <Text>Ilość wyjazdów SGChem</Text>
                                <Input type="number" {...field} w={"100px"} />
                            </Flex>
                            <FormErrorMessage>{form.errors.sgchemDispatches}</FormErrorMessage>
                        </FormControl>
                    )}
                </Field>

                <Field name="sgrmedDispatches">
                    {({ field, form }) => (
                        <FormControl
                            id="sgrmedDispatches"
                            isRequired
                            isInvalid={form.errors.sgrmedDispatches && form.touched.sgrmedDispatches}
                        >
                            <Flex direction={"row"} gap={"10px"} alignItems={"center"} justifyContent={"left"}>
                                <Text>Ilość wyjazdów SGRMed</Text>
                                <Input type="number" {...field} w={"100px"} />
                            </Flex>
                            <FormErrorMessage>{form.errors.sgrmedDispatches}</FormErrorMessage>
                        </FormControl>
                    )}
                </Field>

                <Field name="mostUsedVehicle">
                    {({ field, form }) => (
                        <FormControl
                            id="mostUsedVehicle"
                            isRequired
                            isInvalid={form.errors.mostUsedVehicle && form.touched.mostUsedVehicle}
                        >
                            <Flex direction={"row"} gap={"10px"} alignItems={"center"} justifyContent={"left"}>
                                <Text>Najbardziej eksploatowany pojazd</Text>
                                <Input type="text" {...field} w={"200px"} />
                            </Flex>
                            <FormErrorMessage>{form.errors.mostUsedVehicle}</FormErrorMessage>
                        </FormControl>
                    )}
                </Field>

                <Field name="leastUsedVehicle">
                    {({ field, form }) => (
                        <FormControl
                            id="leastUsedVehicle"
                            isRequired
                            isInvalid={form.errors.leastUsedVehicle && form.touched.leastUsedVehicle}
                        >
                            <Flex direction={"row"} gap={"10px"} alignItems={"center"} justifyContent={"left"}>
                                <Text>Najmniej eksploatowany pojazd</Text>
                                <Input type="text" {...field} w={"200px"} />
                            </Flex>
                            <FormErrorMessage>{form.errors.leastUsedVehicle}</FormErrorMessage>
                        </FormControl>
                    )}
                </Field>

                <Field name="incidentsWithServiceVehicles">
                    {({ field, form }) => (
                        <FormControl
                            id="incidentsWithServiceVehicles"
                            isRequired
                            isInvalid={form.errors.incidentsWithServiceVehicles && form.touched.incidentsWithServiceVehicles}
                        >
                            <Flex direction={"row"} gap={"10px"} alignItems={"center"} justifyContent={"left"}>
                                <Text>Ilość zdarzeń z udziałem pojazdów służbowych</Text>
                                <Input type="number" {...field} w={"100px"} />
                            </Flex>
                            <FormErrorMessage>{form.errors.incidentsWithServiceVehicles}</FormErrorMessage>
                        </FormControl>
                    )}
                </Field>

                <Field name="equipmentFailures">
                    {({ field, form }) => (
                        <FormControl
                            id="equipmentFailures"
                            isRequired
                            isInvalid={form.errors.equipmentFailures && form.touched.equipmentFailures}
                        >
                            <Flex direction={"row"} gap={"10px"} alignItems={"center"} justifyContent={"left"}>
                                <Text>Ilość usterek w sprzęcie ratowniczym</Text>
                                <Input type="number" {...field} w={"100px"} />
                            </Flex>
                            <FormErrorMessage>{form.errors.equipmentFailures}</FormErrorMessage>
                        </FormControl>
                    )}
                </Field>

                <Field name="withdrawnEquipment">
                    {({ field, form }) => (
                        <FormControl
                            id="withdrawnEquipment"
                            isRequired
                            isInvalid={form.errors.withdrawnEquipment && form.touched.withdrawnEquipment}
                        >
                            <Flex direction={"row"} gap={"10px"} alignItems={"center"} justifyContent={"left"}>
                                <Text>Pojazdy/sprzęt wycofany z podziału bojowego w okresie rozliczeniowym</Text>
                                <Input type="text" {...field} w={"200px"} />
                            </Flex>
                            <FormErrorMessage>{form.errors.withdrawnEquipment}</FormErrorMessage>
                        </FormControl>
                    )}
                </Field>
              </SimpleGrid>

              <Button
                mt={4}
                colorScheme="red"
                isLoading={isSubmitting}
                type="submit"
              >
                Wyślij
              </Button>
            </Form>
          )}
        </Formik>
      </Card>
    </Flex>
  );
}

export default Page;
